import { NgFor, NgIf, NgTemplateOutlet } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Inject,
  Input,
  Optional
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_PAGINATOR_DEFAULT_OPTIONS,
  MatPaginator,
  MatPaginatorDefaultOptions,
  MatPaginatorIntl
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { TableComponent } from "src/app/slots/three-year-plan/common/components/table/container/table.component";
import { PaginatorIntl } from "./paginator-intl";

export interface PaginatorDefaultOptions {
  pageSize: number;
  pageIndex?: number;
  length?: number;
  pageSizeOptions?: Array<number | "all">;
  hidePageSize?: boolean;
  showFirstLastButtons?: boolean;
  showPaginationAbove?: boolean;
  showPaginationBelow?: boolean;
}

@Component({
  selector: "tpm-paginator",
  templateUrl: "./paginator.component.html",
  styleUrls: ["./paginator.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ["disabled"],
  host: {
    class: "tpm-paginator",
    role: "group"
  },
  imports: [NgIf, NgFor, NgTemplateOutlet, TranslateModule, MatSelectModule, MatTooltipModule, MatButtonModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntl,
      deps: [TranslateService]
    }
  ]
})
export class PaginatorComponent extends MatPaginator implements AfterViewInit {
  @ContentChild(TableComponent) readonly tableRef?: TableComponent<unknown>;

  @Input() showPaginationAbove: boolean = false;
  @Input() showPaginationBelow: boolean = true;
  @Input() rangeAlign: "left" | "center" = "left";

  @Input()
  set options(_options: PaginatorDefaultOptions) {
    if (_options) {
      this.pageSize = _options.pageSize;

      if ("pageIndex" in _options) {
        this.pageIndex = _options.pageIndex;
      }

      if ("length" in _options) {
        this.length = _options.length;
      }

      if ("pageSizeOptions" in _options) {
        this.pageSizeOptions = _options.pageSizeOptions.map((size) => (size === "all" ? 999999999 : size));
      }

      if ("hidePageSize" in _options) {
        this.hidePageSize = _options.hidePageSize;
      }

      if ("hidePageSize" in _options) {
        this.pageIndex = _options.pageIndex;
      }

      if ("showFirstLastButtons" in _options) {
        this.showFirstLastButtons = _options.showFirstLastButtons;
      }

      if ("showPaginationAbove" in _options) {
        this.showPaginationAbove = _options.showPaginationAbove;
      }

      if ("showPaginationBelow" in _options) {
        this.showPaginationBelow = _options.showPaginationBelow;
      }
    }
  }

  constructor(
    readonly intl: MatPaginatorIntl,
    readonly changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Inject(MAT_PAGINATOR_DEFAULT_OPTIONS)
    readonly defaults?: MatPaginatorDefaultOptions
  ) {
    super(intl, changeDetectorRef, defaults);
  }

  ngAfterViewInit(): void {
    if (this.tableRef) {
      this.tableRef.paginator = this;
    }
  }
}
